export default "__VITE_ASSET__gVZW7QDE__"